export default __webpack_public_path__ + "static/media/2.4ba2f971.png";